import { Component } from '@angular/core';
import {FooterCardComponent} from "./footer-card/footer-card.component";
import {FooterBaseComponent} from "./footer-base/footer-base.component";

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    FooterCardComponent,
    FooterBaseComponent,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

}
